// extracted by mini-css-extract-plugin
module.exports = {"smallCard":"Stats_smallCard__2-k8K","main":"Stats_main__2YwC6"};